var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "v-form",
        { ref: "activarDEEForm" },
        [
          _c(
            "base-card",
            [
              _c("v-card-title", [
                _vm._v(" Activar Documento Equivalente Electrónico (DEE) "),
              ]),
              _c(
                "v-card-text",
                [
                  _vm.isAdmin
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "cliente",
                                attrs: {
                                  items: _vm.detailClients,
                                  "item-text": "text",
                                  "item-value": "IdCompania",
                                  label: "Compañia",
                                  "prepend-inner-icon": "mdi-sitemap",
                                  error: _vm.companySelectorError,
                                  rules: [_vm.validateCompanyField],
                                  "error-messages": _vm.helperSelectorText,
                                  filter: "",
                                  "search-input": "",
                                },
                                on: { change: _vm.handleSelectChange },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "prepend-item",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-list-item",
                                            [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "search-field",
                                                        attrs: {
                                                          placeholder: "Buscar",
                                                          "prepend-inner-icon":
                                                            "mdi-magnify",
                                                          "hide-details": "",
                                                        },
                                                        model: {
                                                          value: _vm.search,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.search = $$v
                                                          },
                                                          expression: "search",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  766180807
                                ),
                                model: {
                                  value: _vm.data.IdCompania,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "IdCompania", $$v)
                                  },
                                  expression: "data.IdCompania",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "2" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  on: { click: _vm.checkCompanyField },
                                },
                                [_vm._v(" Buscar ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.searchIfIsAdmin
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: `${
                                    _vm.data.configStatus
                                      ? "[Activar DEE ]"
                                      : "[Inactivar DEE ]"
                                  }`,
                                  "hide-details": "",
                                  inset: "",
                                },
                                model: {
                                  value: _vm.data.configStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "configStatus", $$v)
                                  },
                                  expression: "data.configStatus",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "2" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  on: { click: _vm.validateConfigData },
                                },
                                [_vm._v(" Guardar ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-alert",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.successAlert,
                              expression: "successAlert",
                            },
                          ],
                          attrs: { type: "success", text: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
                      ),
                      _c(
                        "v-alert",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errorAlert,
                              expression: "errorAlert",
                            },
                          ],
                          attrs: { type: "warning", text: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.msgErrorAlert) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }